import { Link } from "react-router-dom";

export type MappingList = Array<[string, string]>;

export const about: MappingList = [
  ["base", "Basisgegevens"],
  ["soil", "Bodemopbouw"],
  ["chemical", "Bodemchemie"],
  ["archeology", "Archeologie"],
  ["explosive", "Explosieven"],
  ["alien", "Bodemvreemde objecten"],
  ["nutrients", "Nutriënten"],
];

export const organization: MappingList = [
  ["what", "Wat"],
  ["who", "Voor wie?"],
  ["story", "Ons verhaal"],
];

export const LLink = ({ link = "", children }) => (
  <li className="px-3 py-1.5 rounded-sm hover:bg-light-gray">
    <Link to={"/" + link}>{children}</Link>
  </li>
);
export const LinkList = ({ mapping }: { mapping: MappingList }) => (
  <ul className="text-sm font-normal">
    {mapping.map(([link, name], index) => (
      <LLink key={index} link={link}>
        {name}
      </LLink>
    ))}
  </ul>
);
export const CSRF = () => (
  <input
    type="hidden"
    name="csrfmiddlewaretoken"
    value={document.cookie.match(/csrftoken=(\w+)/)[1]}
  />
);
